module.exports = __webpack_public_path__ + "static/media/instructivosc3.ba9fc45d.png";